import React, { Component } from 'react';
import './Common.css';
import './App.css';
import { initWeb3, updateScreenDimensions } from "../actions/betActions";
import { connect } from "react-redux";
import MenuBar from "./MenuBar";
import ProposeBet from "./ProposeBet";
import ViewProposal from "./ViewProposal";
import LinkAccount from "./LinkAccount";
import Summary from "./Summary";
import BrowseBets from "./BrowseBets";
import Overlay from "./Overlay";
import Help from "./Help";
import Splash from "./Splash";
import AuthenticationStatus from './AuthenticationStatus';
import loading from '../loading2.gif';

const stateMap = (store) => {
    return {
        betsInitialized: store.bet.betsInitialized,
        selectedPage: store.bet.selectedPage,
        web3Instance :store.bet.web3.web3Instance,
        loggedIn: store.bet.authentication.loggedIn,
        pageLoaded: store.bet.pageLoaded,
        authentication: store.bet.authentication,
        showOverlay: store.bet.showOverlay
    };
};
class App extends Component {

    constructor(props, context) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.updateScreenDimensions = this.updateScreenDimensions.bind(this);
    }

    updateScreenDimensions() {
        this.props.dispatch(updateScreenDimensions(document.body.clientWidth, document.body.clientHeight));
    }

    componentWillMount() {
        const { web3Instance } = this.props;

        this.updateScreenDimensions();

        if(web3Instance === null) {
            this.props.dispatch(initWeb3());
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateScreenDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateScreenDimensions);
    }

    render() {

    // betsInitialized, 
    const { selectedPage, loggedIn, pageLoaded, authentication } = this.props;
    const { showAuthFlow=false } = authentication;

    let showAuthDetails = true;

    return (
      <div className="App">
        {showAuthDetails && <AuthenticationStatus />}
        {this.props.showOverlay && <Overlay />}
        <MenuBar />
        {!pageLoaded && <div style={{textAlign:"center",marginTop:"30px"}}><img style={{width:"40px", height:"40px"}} src={loading} alt="loading" /></div>}
        {pageLoaded && showAuthFlow && <div><LinkAccount /></div>}
        {pageLoaded && !showAuthFlow && !loggedIn && <div><Splash /></div>}

        {pageLoaded && !showAuthFlow && loggedIn && selectedPage === "SUMMARY" && <Summary />}
        {pageLoaded && !showAuthFlow && loggedIn && selectedPage === "BROWSE_BETS" && <BrowseBets />}
        {pageLoaded && !showAuthFlow && loggedIn && selectedPage === "PROPOSE_BET" && <div><ProposeBet /></div>}
        {pageLoaded && !showAuthFlow && loggedIn && selectedPage === "VIEW_PROPOSAL" && <div><ViewProposal /></div>}
        {pageLoaded && !showAuthFlow && loggedIn && selectedPage === "HELP" && <div><Help /></div>}
        
        <div className="padBottom"></div>
      </div>
    );
  }
}

export default connect(stateMap)(App);



// WEBPACK FOOTER //
// ./src/components/App.js